<template>
  <div class="main">
    <template v-if="assignments.length">
      <h2>
        Tienes {{ assignments.length }}
        {{ assignments.length == 1 ? 'bloqueo reservado' : 'bloqueos reservados' }}
      </h2>
      <div class="assignments">
        <div
          class="assignment-wrap"
          v-for="(assignment, i) in assignments"
          :key="i"
        >
          <div class="assignment">
            <div
              class="assignment-img"
              v-if="assignment.departure.img"
            >
              <img
                :src="'/api/images/departures/' + assignment.departure.img"
                :alt="assignment.name"
              >
            </div>
            <div class="d-flex flex-column justify-content-between h-100">
              <h4 class="assignment-name">
                {{ assignment.departure.alias }} {{ assignment.departure.name }}
              </h4>
              <ul class="assignment-detail">
                <li>
                  REFERENCIA
                  <strong class="txt-upper">{{ assignment.ref }}</strong>
                </li>
                <li>
                  PASAJEROS <strong>{{ assignment.passengers.length }}</strong>
                </li>
                <li class="txt-red">
                  VENCE EL <strong>{{ assignment.expiration }}</strong>
                </li>
              </ul>
              <button
                class="btn btn-black"
                @click="book(assignment)"
              >
                VER DETALLE
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div class="departures">
      <div class="board-search">
        <input
          type="text"
          placeholder="BUSCA TU SALIDA POR DESTINO O FECHA"
          v-model="search"
        >
        <button
          class="board-toggleview"
          :disabled="view == 'list'"
          @click="$router.push({ name: $route.name, query: { list: null } })"
        >
          <span class="icon-menu" />
        </button>
        <button
          class="board-toggleview"
          :disabled="view == 'grid'"
          @click="$router.push({ name: $route.name, query: { grid: null } })"
        >
          <i class="icon-th-large" />
        </button>
      </div>
      <div
        v-if="view == 'grid'"
        class="groups"
      >
        <div
          class="groups-item"
          v-for="(item, i) in groups"
          :key="i"
        >
          <div
            class="group"
            :style="item.style"
            @click.prevent="$router.push({ name: 'group', params: { id: item.group } })"
          >
            <span
              class="pill-green pill-xs"
              v-if="item.fresh"
            >¡NUEVO!</span>
            <span
              class="pill-red pill-xs"
              v-if="item.promo"
            >¡PROMO!</span>
            <div class="group_hover">
              <div>
                <img src="@/assets/check.png">
                <strong>VER TODAS</strong>
                <span>LAS SALIDAS</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <table
        v-if="view == 'list'"
        class="tbl"
      >
        <tr class="text-nowrap">
          <th><span>SALIDA</span></th>
          <th><span /></th>
          <th><span>FECHA SALIDA</span></th>
          <th><span>EMBARQUE</span></th>
          <th><span>DESDE</span></th>
          <th><span /></th>
          <th style="width: 1rem;">
            <span>DISP. MICRO</span>
          </th>
        </tr>
        <tr
          v-for="(item, i) in departures"
          :key="i"
        >
          <td>
            <span>{{ item.alias }} {{ item.name }}</span>
          </td>
          <td>
            <span
              class="pill pill-black pill-xs"
              v-if="!!item.fresh"
            >¡NUEVO!</span>
            <span
              class="pill pill-red pill-xs"
              v-if="!!item.promo"
            >¡PROMO!</span>
          </td>
          <td>
            <span>{{ item.date_departure }}</span>
          </td>
          <td>
            <strong class="txt-orange">{{ item.origin }}</strong>
          </td>
          <td>
            <strong>{{ item.currency }}{{ item.initial_price }}</strong>
          </td>
          <td>
            <router-link
              class="tbl-link"
              :to="{ name: 'departure', params: { id: item.id } }"
              append
            >
              VER DETALLE
            </router-link>
          </td>
          <td style="width: 1rem;">
            <span
              class="pill pill-black"
              v-if="item.free"
            >
              <span class="ico ico-bus ico-xs">{{ item.free }}</span>
            </span>
            <span
              class="pill pill-orange"
              v-else
            >CONSULTAR</span>
          </td>
        </tr>
      </table>
    </div>
    <router-view />
  </div>
</template>
<script>
import { SEAT_STATUS } from '@/constans'
import { search, yyyymmdd_ddmmyyy } from '@/utils'
import { ROOMING, RATE, STATUS, ID, PASSENGERS, SEATS, DEPARTURE } from '@/store/mutations'

export default {
  data () {
    return {
      search: null
    }
  },

  computed: {
    groups () {
      return this.departures
        .reduce(
          (arr, departure) =>
            arr.some(el => el.group == departure.group) ? arr : arr.concat([departure]),
          []
        )
        .map(item => {
          item.style = `background-image: url(/api/images/group/${encodeURIComponent(item.group)}.jpg)`
          return item
        })
    },
    view () {
      return Object.keys(this.$route.query).includes('grid') ? 'grid' : 'list'
    },
    assignments () {
      return this.$store.state.assignments
        .filter(({ departure_id }) =>
          this.$store.state.departures.find(({ id }) => id == departure_id)
        )
        .map(assignment => {
          assignment.expiration = yyyymmdd_ddmmyyy(assignment.expiration)
          assignment.departure = this.$store.state.departures.find(
            departure => departure.id == assignment.departure_id
          )
          return assignment
        })
    },
    departures () {
      return search(this.$store.state.departures, this.search).map(departure => {
        departure.free = parseInt(departure.bus.available)
          ? Object.values(departure.bus.seating).filter(
            seat => seat.status == SEAT_STATUS.free.str
					  ).length
          : 0
        return departure
      })
    }
  },
  methods: {
    book (assignment) {
      this.$router
        .push({
          name: 'departure',
          params: { id: assignment.departure.id, tab: 'reservar' }
        })
        .then(() => {
          var departure = this.$store.state.departures.find(
            departure => departure.id == assignment.departure.id
          )
          var rate = departure.rates.find(rate => rate.id == assignment.rate_id)

          this.$store.commit('booking/' + DEPARTURE, departure)
          this.$store.commit('booking/' + RATE, rate)
          this.$store.commit('booking/' + ID, assignment.id)
          this.$store.commit('booking/' + PASSENGERS, assignment.passengers)
          this.$store.commit('booking/' + SEATS, assignment.seats)
          this.$store.commit(
            'booking/' + ROOMING,
            assignment.rooming.map(rooming => ({ passengers: [], ...rooming }))
          )
          this.$store.commit('booking/' + STATUS, 'rooming')
        })
    }
  }
}
</script>
